import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircleIcon } from "@heroicons/react/24/outline";

const VerificationFailed = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        className="w-full max-w-md"
      >
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl border border-gray-200/20 p-8 text-center">
          {/* Error Icon */}
          <motion.div
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            className="mx-auto w-16 h-16 bg-red-500/20 rounded-full flex items-center justify-center mb-6"
          >
            <XCircleIcon className="w-8 h-8 text-red-400" />
          </motion.div>

          {/* Error Message */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="text-2xl font-bold text-white mb-4"
          >
            {t("auth.verificationFailed", "Verification Failed")}
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="text-gray-300 mb-8 leading-relaxed"
          >
            {t(
              "auth.invalidOrExpiredToken",
              "Invalid ID or expired verification token. Please try again or contact support if the problem persists."
            )}
          </motion.p>

          {/* Action Buttons */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="space-y-4"
          >
            <Link
              to="/login"
              className="block w-full bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg"
            >
              {t("auth.backToLogin", "Back to Login")}
            </Link>

            <Link
              to="/"
              className="block w-full bg-gray-700/50 hover:bg-gray-600/50 text-gray-200 font-semibold py-3 px-6 rounded-xl transition-all duration-200 border border-gray-600/50"
            >
              {t("common.goHome", "Go Home")}
            </Link>
          </motion.div>

          {/* Additional Help */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
            className="mt-8 pt-6 border-t border-gray-700/50"
          >
            <p className="text-sm text-gray-400">
              {t(
                "auth.needHelp",
                "Need help? Contact our support team for assistance."
              )}
            </p>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default VerificationFailed; 